import React, { useEffect, useState } from "react";
import EnterEmailOtp from "./EnterEmailOtp";
import EnterMobileOtp from "./EnterMobileOtp";
import SetPassWord from "./SetPassWord";
import axios from "../../axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function VerifyEmailMobile({
  studentDetails,
  setEmailPhoneVerification,
  emailPhoneVerification,
  setRegister,
  setIsInProgress,
  register
}) {
  const { verifiedEmail, verifiedMobile } = emailPhoneVerification;
  const [verify, setVerify] = useState({
    verifyEmail: false,
    // verifyMobile: false,
    setPassword: false,
  });

  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const header = searchParams.get("unreg");
  const user = searchParams.get("userId");
  const schoolCode = searchParams.get("schoolCode") || "";
  const schoolCodeFromLocal = localStorage.getItem("schoolCode");

  useEffect(() => {
    const disableBackButton = (e) => {
      const searchParams = new URLSearchParams(location.search);
      const unreg = searchParams.get("unreg") || "";
      const userId = searchParams.get("userId") || "";
      const schoolCode = searchParams.get("schoolCode") || "";

      window.history.pushState(
        null,
        document.title,
        `${window.location.href}?unreg=${unreg}&userId=${userId}&schoolCode=${schoolCode}`
      );
    };

    window.addEventListener("popstate", disableBackButton);

    return () => {
      window.removeEventListener("popstate", disableBackButton);
    };
  }, []);

  const handleEmailOtpVarification = async () => {
    try {
      let response = await axios.post(`/studentAuth/generateEmailOtp`, {
        email_id: studentDetails?.email,
      });
      response && setVerify({ ...verify, verifyEmail: true });
    } catch (error) {
      console.log(error);
    }
  };

  //This is part of verify with mobile no
  // const handlePhoneOtpVarification = async () => {
  //   try {
  //     let response = await axios.post(`/studentAuth/generateMobileOtp`, {
  //       mobile_number: studentDetails?.mobileNumber,
  //     });
  //     response && setVerify({ ...verify, verifyMobile: true });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (header !== "true" || !user) {
      setVerify({ ...verify, setPassword: true });
    } else {
      try {
        await axios.post(`/studentAuth/unregister`, {
          unique_id: user,
          school_code: schoolCode || schoolCodeFromLocal,
        });

        navigate("/unRegSuccessful");
      } catch (error) {
        console.log(error);
      }
    }
  };
  //This method use for hide some part of email
  const MaskedEmail = (email) => {
    const maskEmail = (email) => {
      if (!email || typeof email !== 'string') return email;

      const [localPart, domain] = email.split('@');
      if (!localPart || !domain) return email;

      // Mask local part
      const firstPart = localPart.slice(0, 2);
      const maskedLocalMiddle = '*'.repeat(Math.max(localPart.length - 4, 5));
      // const lastPart = localPart.slice(-1);

      // Mask domain
      const [domainName, domainExtension] = domain.split('.');
      const maskedDomainMiddle = '*'.repeat(Math.max(domainName.length - 2, 3));
      // const firstDomainPart = domainName.slice(0, 1);
      const lastDomainPart = domainName.slice(-1);

      const maskedDomain = `${maskedDomainMiddle}${lastDomainPart}.${domainExtension}`;

      return `${firstPart}${maskedLocalMiddle}@${maskedDomain}`;
    };

    return <p>{maskEmail(email)}</p>;
  };

  return (
    <>
      {!verify.setPassword && (
        <div>
          {/* I removed !verify.verifyMobile this is part of verify with mobile no */}

          {!verify.verifyEmail && (
            <div className="ContainerRegister h-100">
              <div className="row">
                <div className="col-md-3 p-0 bannerContainer">
                  <img
                    className="bannerImg"
                    alt="icon"
                    src="/LoginRegister/BannerImg.png"
                  ></img>

                </div>
                <div className="col-md-9 RegisterDetailContainer" style={{ position: "relative" }}>
                  <>
                    {/* <div style={{ position: "absolute", top: "15px", left: "25px", cursor: "pointer" }} onClick={() => setRegister((prev) => ({ ...prev, verify: false }))}>
                      <img src="/images/back_arrow.svg" alt="img" />
                    </div> */}
                    <div
                      className="backLoginIcon"
                      onClick={(e) => { setIsInProgress(false); setRegister((prev) => ({ ...prev, verify: false })); setEmailPhoneVerification((prev) => ({ ...prev, verifiedEmail: false, verifiedMobile: false })) }}
                    >
                      <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                    </div>

                    <form>
                      <div className="InsideDetailCpntainer">
                        <div className="d-flex justify-content-center">
                          <img
                            className="registrationIcon"
                            src="/StudentImg/BreathSchoolLogo.png"
                            alt="icon"
                          />
                        </div>
                        <div className="d-flex justify-content-center headerRegistration mt-3">
                          {header === "true" ? "Unregister" : "Registration"}
                        </div>
                        <div className=" mt-4">
                          <div className="d-flex justify-content-between align-items-center verifyInputContainer p-3">
                            <div>
                              <div className="EmailIdHeader">Email ID</div>
                              <div className="EmailId">
                                {MaskedEmail(studentDetails?.email)}
                              </div>
                            </div>

                            {verifiedEmail ? (
                              <div>
                                <img
                                  src="/LoginRegister/VerifiedTick.png"
                                  alt="icon"
                                />
                              </div>
                            ) : (
                              <div
                                className="VerifyText"
                                onClick={handleEmailOtpVarification}
                              >
                                Verify Now
                              </div>
                            )}
                          </div>
                          {/* Here I commentend code for hide option verify with mobile_number */}
                          {/* <div className="d-flex mt-3 justify-content-between align-items-center verifyInputContainer p-3">
                            <div>
                              <div className="EmailIdHeader">Mobile Number</div>
                              <div className="EmailId">
                                {studentDetails?.mobileNumber}
                              </div>
                            </div>

                            {verifiedMobile ? (
                              <div>
                                <img
                                  src="/LoginRegister/VerifiedTick.png"
                                  alt="icon"
                                />
                              </div>
                            ) : (
                              <div
                                className="VerifyText"
                                onClick={handlePhoneOtpVarification}
                              >
                                Verify Now
                              </div>
                            )}
                          </div> */}
                        </div>
                        <div className="d-flex justify-content-center mt-4">
                          {verifiedEmail && (
                            <button
                              disabled={!verifiedEmail}
                              onClick={handleSubmit}
                              className="RegisterBtn2"
                            >
                              {/* Here I removed verifiedMobile because it is not allow me to set new password */}
                              {
                                verifiedEmail &&
                                  header === "true"
                                  ? "Unregister"
                                  : "Continue"}
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  </>
                </div>
              </div>
            </div>
          )}
          {verify.verifyEmail && (
            <EnterEmailOtp
              studentDetails={studentDetails}
              setEmailPhoneVerification={setEmailPhoneVerification}
              emailPhoneVerification={emailPhoneVerification}
              setVerify={setVerify}
              setRegister={setRegister}
              setIsInProgress={setIsInProgress}
            />
          )}
          {/* Here I commentend for verify mobile no with opt */}
          {/* {verify.verifyMobile && (
            <EnterMobileOtp
              studentDetails={studentDetails}
              setEmailPhoneVerification={setEmailPhoneVerification}
              emailPhoneVerification={emailPhoneVerification}
              setVerify={setVerify}
              setRegister={setRegister}
              setIsInProgress={setIsInProgress}
            />
          )} */}
        </div>
      )}
      {verify.setPassword && (
        <SetPassWord
          studentDetails={studentDetails}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
    </>
  );
}
